import slice from "./usersSlice";

export default slice.reducer;
